<template lang="pug">
  v-navigation-drawer(
      app
      :clipped="clipped"
      :fixed="fixed"
      v-model="drawer"
      floation="true"
      width="400"
    )
    v-flex(xs10 offset-xs1 mt-4)
        map-menu-noise-data
        map-menu-filter-dialog
        map-menu-add-barrier
        map-review-dialog
        map-menu-calculate-from-model
</template>

<script>
import { mapGetters } from "vuex";
import MapMenuNoiseData from "@/components/map/MapMenuNoiseData";
import MapMenuAddBarrier from "@/components/map/MapMenuAddBarrier";
import MapMenuFilterDialog from "@/components/map/MapMenuFilterDialog";
import MapMenuCalculateFromModel from "@/components/map/MapMenuCalculateFromModel";
import MapReviewDialog from "@/components/map/MapReviewDialog";

export default {
  components: {
    MapMenuNoiseData,
    MapMenuAddBarrier,
    MapMenuFilterDialog,
    MapMenuCalculateFromModel,
    MapReviewDialog
  },
  name: "MapMenu",
  data() {
    return {
      loader: null,
      clipped: true,
      fixed: false
    };
  },
  computed: {
    ...mapGetters([
      "filterDateTime",
      "filterDate",
      "filterTime",
      "filterButtonLoading"
    ]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set() {
        return;
      }
    },
    snackbar: {
      get() {
        return this.$store.state.toast;
      },
      set(val) {
        this.$store.dispatch("SET_TOAST", val);
      }
    },
  }
};</script>
